<template>
    <div style="height: 100%; position: relative; display: flex; flex-direction: column;">
        <div style="background-color: #fff; z-index: 10;">
            <div style="display: flex; justify-content: center; align-items: center; gap: 4px; background-color: #fff; min-height: 56px; padding: 8px 0; position: relative;">
                <div v-if="isShowSwitchBtn" style="display:grid; place-items: center;font-weight: 700; line-height: 24px;">
                    메시지
                    <!--<SwitchTab :initSetTabIndex="initSetTabIndex" :tabs="tabs"/>-->
                </div>
                <OptionBtn :setIsShowTopBtn="() => {}" :pageName="PAGE_NAME.MEMBER_TALK"></OptionBtn>
            </div>
        </div>
        <div style="flex: 1;"></div>

        <Transition name="fade">
            <InfinityScroll v-show="curType === BTN_TYPE.RECRUIT" :style="{ paddingBottom: 64 + $GlobalStore.navigationBarHeight() + $GlobalStore.statusBarHeight() + 'px' }" style="height: 100%; width: 100%; position: absolute;" :handle-next-page="handleNextPageRecruit" :is-enable-next-page-handle="isEnableNextPageHandleRecruit" :refresh-action="refreshRecruit">

                <template v-if="!isExpert">
                    <div style="display: flex; gap: 8px; padding-left: 12px; margin-top: 12px;  margin-top: 62px;">
                        <div :style="{ border: cur_membertalk_btn_type === MEMBERTALK_BTN_TYPE.CLOSE_MERCENARY ? '2px solid #210f03' : '' }" @click="setMemberTalkBtnType(MEMBERTALK_BTN_TYPE.CLOSE_MERCENARY); $Util.sendEventClick('멤버_가까운용병')" class="message_top_btn" style="width: 94px">가까운 용병</div>
                        <div :style="{ border: cur_membertalk_btn_type === MEMBERTALK_BTN_TYPE.FRIEND ? '2px solid #210f03' : '' }" @click="setMemberTalkBtnType(MEMBERTALK_BTN_TYPE.FRIEND); $Util.sendEventClick('멤버_내친구')" class="message_top_btn" style="width: 62px;">내 친구</div>
                    </div>

                    <div v-if="cur_membertalk_btn_type === MEMBERTALK_BTN_TYPE.CLOSE_MERCENARY">
                        <div v-if="nearbyMercenaryList.length > 0" class="hide_scroll" style="display:flex;overflow-x: auto; padding-left:12px; margin:15px 0px 10px 0px;">
                            <div style="white-space: nowrap; margin-right:15px;width:66px;" v-for="each, i in nearbyMercenaryList" :key="i" @click="$Util.showProfile(each.member_idx)">
                                <div style="border-radius:50%; border:3px solid #808080;width:66px; height:66px;">
                                    <ProfileImage style="width: 60px;" :image-path="each.image_path" :is-show-border="false" />
                                </div>
                                <div style="display:grid; place-items: center; width:100%;">
                                    <div class="hide_scroll" style="max-width:100%; overflow-x: auto; display:flex;margin-top:3px;height:16px; align-items: center " @touchstart.stop="() => {}" @click.stop="() => {}">
                                        <div style="display:inline-block; font-weight:bold; font-size:12px; white-space: nowrap;">{{each.nic_name}} <span v-if="each.position" style="font-weight:bold; font-size:12px; color:#FF7111;">{{each.position}}</span></div>
                                    </div>
                                </div>
                                <div style="display:grid; place-items: center; width:100%;">
                                    <div class="hide_scroll" style="max-width:100%; overflow-x: auto; display:flex; font-size:12px; color:#6B6B6B; ">{{each.age_range}}·{{each.place_name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div v-if="cur_membertalk_btn_type === MEMBERTALK_BTN_TYPE.FRIEND" style="margin:25px 0px 10px 0px; padding:0px 12px;" @click="showMyFriendsPopup">
                        <div style="display:flex; align-items: center; align-self: center;">
                            <div style="width:70px; height:55px; position:relative;">
                                <div style="position:absolute; left:0px; top:0px; width:40px;height:40px;border-radius:50%; border:1px solid #808080;">
                                    <ProfileImage style="width:38px;" :image-path="friends[0] && friends[0].image_path ? friends[0].image_path : null" :is-show-border="false"/>
                                </div>
                                <div style="position:absolute; left:15px; top:15px; width:40px;height:40px;border-radius:50%; border:1px solid #808080;">
                                    <ProfileImage style="width:38px;" :image-path="friends[1] && friends[1].image_path ? friends[1].image_path : null" :is-show-border="false"/>
                                </div>
                            </div>
                            <div style="flex:1;">
                                <div style="color:#070707; font-size:16px; font-weight:bold;">내 친구 목록</div>
                                <div style="color:#606060; font-size:14px; font-weight:500; margin-top:3px;">{{friends[0] && friends[0].nic_name ? friends[0].nic_name : ''}}{{friends[1] && friends[1].nic_name ? ', ' + friends[1].nic_name : ''}} 님 외 {{friends.length - 1}}명</div>
                            </div>
                            <img :src="require('@/assets/img/friend_down_arrow.png')" style="width:10px;">
                        </div>
                        <div style="height:1px; background-color:#F5F5F5; margin-top:25px;"></div>
                        <div style="height:6px;"></div>
                    </div> -->
                </template>

                <div v-if="!isExpert" style="padding:12px;">
                    <InteractionOfScale>
                    <div style="display: flex; justify-content: space-between; align-items: center; background: linear-gradient(180deg, #FFEA01 12.5%, rgba(92, 92, 92, 0.84) 100%); padding: 18px 12px; height: 100px; border-radius: 12px;" @click="makeMemberTalk">
                        <div>
                            <div style="color: rgb(255, 255, 255); font-size: 17px; font-weight: 700; line-height: 24px; white-space: nowrap;">축구 같이 하실 멤버가 필요하신가요?</div>
                            <div style="font-size: 13px; font-weight: 500; line-height: 20px; white-space: nowrap;">내 주변에서 같이 축구할 멤버를 찾아보세요!</div>
                            <div style="font-size: 13px; font-weight: 500; line-height: 20px; white-space: nowrap;">함께라서 더 즐거워요!</div>
                        </div>
                        <div><img :src="require('@/assets/img/membertalk_create_banner_plus.png')" alt="" style="width: 104px;"></div>
                    </div>
                    </InteractionOfScale>
                </div>

                <div v-if="isExpert" style="margin-top: 12px; padding: 0 12px; margin-top: 65px;">
                    <div class="make_member_wrapper" style="">
                        <div style="font-weight: 700; font-size: 20px; line-height: 32px;">내가 코칭하는 회원들을 관리하세요</div>
                        <div style="margin-top: 4px; line-height: 24px; font-weight: 500;">채팅을 만들어 관리 시작하세요.<br>이전 회원들과 앞으로 만날 회원들도 함께 챙겨주세요. </div>
                        <div @click="showMakeMemberTalk(); $Util.sendEventClick('채팅_멤버톡생성')" style="width: 198px; margin: 0 auto; font-size: 14px; font-weight: 500; color: #210f03; margin-top: 20px; display: flex; justify-content: center; align-items: center; height: 46px; border-radius: 32px; background: #FFFFFFCC;">회원 관리 채팅 만들기</div>
                    </div>
                    <div v-if="chatList.length !== 0" style="margin-top: 16px;">
                        <div style="font-weight: 700; line-height: 24px; margin-bottom: 12px;">진행중인 채팅</div>
                        <div v-for="each, i in chatList" :key="i" style="margin-bottom: 16px;">
                            <MemberListNew :joinMemberTalkConfirm="(join) => { showChat(join, i, true) }" :index="i" :isInvitation="true" :memberList="each"></MemberListNew>
                        </div>
                    </div>
                    <div style="text-align: center; margin-top: 16px;" v-else>
                        <img style="width: 47px;" :src="require('@/assets/img/no_data.png')" alt="">
                        <div style="font-weight: 700;line-height: 24px; margin-top: 20px;">진행중인 멤버톡이 없어요</div>
                    </div>
                </div>

                <div style="margin-top: 12px; padding: 0 12px; margin-top: 12px;" v-else>
                    <!--<div class="make_member_wrapper common_wrapper" style="">-->
                        <!--<div style="font-weight: 700; font-size: 20px; line-height: 32px;">우리팀에 딱 맞는 멤버를 찾아보세요</div>-->
                        <!--<div style="margin-top: 4px; line-height: 24px; font-weight: 500;">매주 축구하는 우리만의 팀을 만들거나 용병을 구하는 곳에 직접 참여할 수도 있습니다</div>-->
                        <!--<InteractionOfScale>-->
                            <!--<div @click="makeMemberTalk" style="width: 157px; margin: 0 auto; font-size: 14px; font-weight: 500; color: #210f03; margin-top: 20px; display: flex; justify-content: center; align-items: center; height: 46px; border-radius: 32px; background: #FFFFFFCC;">멤버톡 만들기</div>-->
                        <!--</InteractionOfScale>-->
                    <!--</div>-->
                    <!--<div style="margin-top: 40px;">-->
                        <!--<div style="font-weight: 700; line-height: 24px;">가까이<span style="font-weight: 500;">에 있는</span>&nbsp;모든 용병</div>-->
                        <!--<div style="margin-top: 4px; font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">경기 뛰기가 목적인 프로필이 표시되고 있습니다</div>-->
                        <!--<div class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 16px; margin: 0 -12px; padding: 0 12px; margin-top: 12px;">-->
                            <!--<MemberTalkBox v-for="each, i in nearbyMercenaryList" :backgroundImagePath="each.image_path" :memberInfo="each" :key="i" :boxType="MEMBER_TALK_BOX_TYPE.MERCENARY"></MemberTalkBox>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div style="margin-top: 40px;">-->
                        <!--<div style="font-weight: 700; line-height: 24px;">지역별 멤버톡</div>-->
                        <!--<div class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 16px; margin: 0 -12px; padding: 0 12px; margin-top: 12px;">-->
                            <!--<div @click="openChat(each.region, each); $Util.sendEventClick('채팅_지역별멤버톡', true)" v-for="each, i in nationwideList" :key="i + 'nationwide'">-->
                                <!--<MemberTalkBox :nationwideList="each" :boxType="MEMBER_TALK_BOX_TYPE.MEMBER_TALK"></MemberTalkBox>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <div style="">
                        <div style="font-weight: 700; line-height: 24px; margin-bottom: 15px;">모든 멤버톡</div>

                        <div style="display:flex; margin-bottom:20px;">
                            <!-- 필터 -->
                            <div style="display: flex; gap: 8px; margin-right:10px; ">
                                <div @click="showAgeFilters(); $Util.sendEventClick(`멤버_멤버톡_필터_나이대`, true)" :style="{ border: cur_age_sort_key !== '모든 나이대' ? '2px solid #210f03' : '1px solid #d9d9d9' }" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                                    <div style="line-height: 24px; ">{{cur_age_sort_key}}</div>
                                    <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                                </div>
                            </div>

                            <div style="display: flex; gap: 8px;">
                                <div @click="showTagFilters(); $Util.sendEventClick(`멤버_멤버톡_필터_태그`, true)" :style="{ border: cur_tag_sort_key !== '멤버톡 태그' ? '2px solid #210f03' : '1px solid #d9d9d9' }" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                                    <div style="line-height: 24px; ">{{cur_tag_sort_key}}</div>
                                    <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                                </div>
                            </div>
                        </div>

                        <div v-for="each, i in chatList" :key="i" style="margin-bottom: 16px;">
                            <MemberTalkList :joinMemberTalkConfirm="(item) => { joinMemberTalkConfirm(item, i, true) }" :index="i" :isInvitation="true" :memberList="each"></MemberTalkList>
                        </div>

                    </div>
                    <div style="text-align: center; margin-top: 40px;" v-if="chatList.length === 0">
                        <img style="width: 47px;" :src="require('@/assets/img/no_data.png')" alt="">
                        <div style="font-weight: 700;line-height: 24px; margin-top: 20px;">진행중인 멤버톡이 없어요</div>
                    </div>
                </div>
            </InfinityScroll>
        </Transition>

        <Transition name="fade">
            <InfinityScroll v-show="curType === BTN_TYPE.MESSAGE" style="height: 100%;" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh">
                <!-- <div v-if="friends.length > 0" class="hide_scroll" style="display:flex;overflow-x: auto; padding-left:12px; margin:15px 0px 10px 0px;">
                    <div style="white-space: nowrap; margin-right:15px;width:66px;" v-for="each, i in friends" :key="i" @click="showPersonalChatFromProfile(each.member_idx)">
                        <div style="width:66px; height:66px;">
                            <ProfileImage style="width: 60px;" :image-path="each.image_path"  />
                        </div>
                        <div style="display:grid; place-items: center; width:100%;">
                            <div class="hide_scroll" style="max-width:100%; overflow-x: auto; display:flex;margin-top:3px;height:16px; " @touchstart.stop="() => {}" @click.stop="() => {}">
                                <div style="display:inline-block; font-weight:bold; font-size:13px; white-space: nowrap;">{{each.nic_name}}  <span v-if="each.position" style="font-weight:bold; font-size:12px; color:#FF7111;">{{each.position}}</span></div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div v-if="messageBanners.length > 0" style="padding: 0 12px; border-radius: 12px; overflow: hidden;">
                    <SwipedHomeBannerSmall :overflow="'hidden'" style="padding-bottom: 0;" :home_banners="messageBanners" />
                </div>

                <!-- <div style="padding:0px 12px;" @click="showFriendsList">
                    <div style="height:1px; background-color:#F5F5F5; margin: 15px 0;"></div>
                    <div style="display:flex; align-items: center; align-self: center;">
                        <div style="width:70px; height:55px; position:relative;">
                            <div style="position:absolute; left:0px; top:0px; width:40px;height:40px;border-radius:50%; border:1px solid #808080;">
                                <ProfileImage style="width:38px;" :image-path="friends[0] && friends[0].image_path ? friends[0].image_path : null" :is-show-border="false"/>
                            </div>
                            <div style="position:absolute; left:15px; top:15px; width:40px;height:40px;border-radius:50%; border:1px solid #808080;">
                                <ProfileImage style="width:38px;" :image-path="friends[1] && friends[1].image_path ? friends[1].image_path : null" :is-show-border="false"/>
                            </div>
                        </div>
                        <div style="flex:1;">
                            <div style="color:#070707; font-size:16px; font-weight:bold;">내 친구 목록</div>
                            <div v-if="friends.length > 0" style="color:#606060; font-size:14px; font-weight:500; margin-top:3px;">{{friends[0] && friends[0].nic_name ? friends[0].nic_name : ''}}{{friends[1] && friends[1].nic_name ? ', ' + friends[1].nic_name : ''}} 님 외 {{friends.length - 1}}명</div>
                            <div v-else style="color:#606060; font-size:14px; font-weight:500; margin-top:3px;">0명</div>
                        </div>
                        <img :src="require('@/assets/img/friend_down_arrow.png')" style="width:10px;">
                    </div>
                    <div style="height:1px; background-color:#F5F5F5; margin: 15px 0;"></div>
                </div> -->

                <div style="display: flex; gap: 8px; padding-left: 12px; margin-top: 12px;">
                    <div :style="{ border: curMessageBtnType === MESSAGE_BTN_TYPE.ALL ? '2px solid #210f03' : '' }" @click="setMessageBtnType(MESSAGE_BTN_TYPE.ALL); $Util.sendEventClick('채팅_전체보기')" class="message_top_btn" style="width: 62px;">전체</div>
                    <div v-if="!isExpert && $GlobalStore.isLogin()" :style="{ border: curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_MESSAGE ? '2px solid #210f03' : '' }" @click="setMessageBtnType(MESSAGE_BTN_TYPE.DIRECT_MESSAGE); $Util.sendEventClick('채팅_다이렉트메시지보기')" class="message_top_btn" style="width: 94px;">스카웃 요청</div>
                    <div v-else-if="isExpert" :style="{ border: curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_REQUEST ? '2px solid #210f03' : '' }" @click="setMessageBtnType(MESSAGE_BTN_TYPE.DIRECT_REQUEST); $Util.sendEventClick('채팅_다이렉트요청서보기')" class="message_top_btn" style="width: 94px;">입단 요청서</div>
                    <div v-if="isExpert" :style="{ border: curMessageBtnType === MESSAGE_BTN_TYPE.TRAINING_FEEDBACK ? '2px solid #210f03' : '' }" @click="setMessageBtnType(MESSAGE_BTN_TYPE.TRAINING_FEEDBACK); $Util.sendEventClick('채팅_훈련피드백')" class="message_top_btn" style="width: 94px;">훈련 피드백</div>
                    <div v-if="$GlobalStore.isLogin()" :style="{ border: curMessageBtnType === MESSAGE_BTN_TYPE.MESSAGE ? '2px solid #210f03' : '' }" @click="setMessageBtnType(MESSAGE_BTN_TYPE.MESSAGE); $Util.sendEventClick('채팅_메시지보기')" class="message_top_btn" style="width: 62px;">메시지</div>
                </div>
                <div v-if="curMessageBtnType === MESSAGE_BTN_TYPE.TRAINING_FEEDBACK" style="margin-top: 16px; padding: 0 12px; font-weight: 500;">{{ feedbackCnt }}개의 훈련 피드백 요청이 있습니다</div>
                <template v-if="messages.length > 0">
                    <template v-for="each, i in messages">
                        <!-- 입단 요청서 -->
                        <template v-if="$hasOwnProperty(each, 'status') && ['0'].indexOf(each.type) > -1">
                            <div @click="showReqeustDetail(each); $Util.sendEventClick('채팅_요청서_자세히보기')" :key="i + 'direct_request'" style="margin-top: 20px; padding: 0 12px;">
                                <div style="display: flex; gap: 8px; align-items: center;">
                                    <div @click="$Util.showProfile(each.from_member.idx)">
                                        <ProfileImage style="width: 40px;"></ProfileImage>
                                    </div>
                                    <div>
                                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 4px;">{{ each.from_member.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ each.from_member.position }}</span></div>
                                        <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #808080;">
                                            {{ each.from_member && each.from_member.place ? each.from_member.place.name : ''}}
                                            <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                                            {{ each.insert_date | agoDateStr }}
                                        </div>
                                    </div>
                                </div>
                                <div style=" border-radius: 12px; margin-top: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px;">
                                    <div style="font-weight: 500; font-size: 15px; line-height: 22px;">
                                        {{ each.soccerhow ? each.soccerhow.contents : '' }}
                                    </div>
                                    <div style="display: flex; justify-content: center; gap: 8px; margin-top: 12px;">
                                        <template v-if="each.is_accepted == 1">
                                            <div @click.stop="() => { showCoachChat(i); $Util.sendEventClick('채팅_요청서대화하기') }" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background-color: var(--color-main); text-align: center; font-size: 14px; font-weight: 700;">대화하기</div>
                                        </template>
                                        <template v-else-if="each.is_skip == 1">
                                            <div style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background: #210F031A; text-align: center; font-size: 14px; font-weight: 700;">거절함</div>
                                        </template>
                                        <template v-else>
                                            <div @click.stop="setModal(MODAL_TYPE.REJECT, i, each); $Util.sendEventClick('채팅_요청서거절')" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background: #210F031A; text-align: center; font-size: 14px; font-weight: 700;">거절하기</div>
                                            <div @click.stop="setModal(MODAL_TYPE.ACCEPT, i, each); $Util.sendEventClick('채팅_요청서수락')" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background-color: var(--color-main); text-align: center; font-size: 14px; font-weight: 700;">메시지 수락</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- 다이렉트 메시지 / 스카웃 요청 -->
                        <template v-else-if="$hasOwnProperty(each, 'status') && ['1','2','3'].indexOf(each.type) > -1">
                            <div :key="i + 'direct_message'" style="margin-top: 20px; padding: 0 12px;" :style="{marginTop : curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_REQUEST || curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_MESSAGE ? '20px' : '12px'}">
                                <template v-if="curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_REQUEST || curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_MESSAGE">
                                    <div style="display: flex; gap: 8px; align-items: center;">
                                        <div @click="$Util.showProfile(each.from_member.idx)">
                                            <ProfileImage :imagePath="each.from_member.image_path" style="width: 40px;"></ProfileImage>
                                        </div>
                                        <div>
                                            <div style="font-weight: 700; font-size: 14px; margin-bottom: 4px;">
                                                {{ each.from_member.nic_name }}
                                                <span>
                                                    <img v-if="each.from_member.team && each.from_member.team.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                                </span>
                                            </div>
                                            <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #808080;">
                                                {{ each.from_member.team ? each.from_member.team.name : '' }}
                                                <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                                                {{ each.insert_date | agoDateStr }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div style="display:flex;" @click="toggleMore(i)">
                                        <div style="display:flex; align-items: center;">
                                            <div style="" >
                                                <ProfileImage style="width: 60px; height: 60px;" :image-path="each.from_member.image_path"></ProfileImage>
                                            </div>
                                        </div>

                                        <div style="flex:1;padding-left:8px;overflow:hidden;">
                                            <div v-if="$hasOwnProperty(each, 'status') && ['0'].indexOf(each.type) > -1" style="font-size:12px; font-weight:bold; margin-top:5px; background-color:#1E68D7; color:white; border-radius:5px; display:inline-block;padding:5px;">입단 요청서</div>
                                            <div v-else-if="$hasOwnProperty(each, 'status') && ['1','2','3'].indexOf(each.type) > -1" style="font-size:12px; font-weight:bold; margin-top:5px; background-color:#FF7111; border-radius:5px; display:inline-block;padding:5px;">스카웃 요청</div>
                                            <div style="font-size:14px; color:#210F03; font-weight:700; margin-top:5px;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">{{each.from_member.nic_name}}
                                                <span>
                                                    <img v-if="each.from_member.team && each.from_member.team.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                                </span>
                                            </div>
                                            <!-- <div style="font-size: 12px;color: rgb(96, 96, 96);line-height: 16px;margin-top: 5px;overflow: hidden;text-overflow: ellipsis;font-weight: 500;">{{$hasOwnProperty(each, 'is_show_more') ? '&nbsp;' : each.contents}}</div> -->
                                        </div>

                                        <div style="width:70px; display: flex; flex-direction: column; justify-content: center; align-items: flex-end; gap: 6px;">
                                            <div style="border-radius:12px; width:33px ;height:20px; text-align: right; color:white; font-size:14px; display:grid; place-items: center;">&nbsp;</div>
                                            <div style="font-size:12px; color:#606060; text-align:right; font-weight: 500; width:100%; display: flex; white-space: nowrap; gap: 4px; justify-content: flex-end; align-items: center;">
                                                <div>{{ each.insert_date | agoDateStr }}</div>
                                            </div>
                                        </div>
                                    </div>

                                </template>

                                <div v-if="true || $hasOwnProperty(each, 'is_show_more') || (curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_REQUEST || curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_MESSAGE)" style=" border-radius: 12px; margin-top: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px;">
                                    <CommonPost :isChat="true" :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="each"></CommonPost>
                                    <div style="display: flex; justify-content: center; gap: 8px; margin-top: 12px;">
                                        <template v-if="each.is_accepted == 1">
                                            <div @click.stop="() => { showCoachChat(i); $Util.sendEventClick('채팅_요청서대화하기') }" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background-color: var(--color-main); text-align: center; font-size: 14px; font-weight: 700;">대화하기</div>
                                        </template>
                                        <template v-else-if="each.is_skip == 1">
                                            <div style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background: #210F031A; text-align: center; font-size: 14px; font-weight: 700;">다음에 보기</div>
                                        </template>
                                        <template v-else>
                                            <div @click="setModal(MODAL_TYPE.REJECT, i); $Util.sendEventClick('채팅_다이렉트메시지거절')" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background: #210F031A; text-align: center; font-size: 14px; font-weight: 700;">다음에 보기</div>
                                            <div @click="setModal(MODAL_TYPE.ACCEPT, i); $Util.sendEventClick('채팅_다이렉트메시지수락')" style="border-radius: 20px; width: 105px; height: 40px; line-height: 40px; background-color: var(--color-main); text-align: center; font-size: 14px; font-weight: 700;">메시지 수락</div>
                                        </template>
                                    </div>
                                </div>

                            </div>
                        </template>
                        <!-- 훈련 피드백 -->
                        <template v-else-if="$hasOwnProperty(each, 'status') && ['4'].indexOf(each.type) > -1">
                            <div v-if="each.is_skip == 0 && each.is_accepted == 0" :key="'feedback_' + i" style="padding: 0 12px; margin-top: 12px;">
                                <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px;">
                                    <div @click="$Util.showProfile(each.from_member.idx)">
                                        <ProfileImage style="width: 40px;"></ProfileImage>
                                    </div>
                                    <div>
                                        <div style="font-weight: 700; font-size: 14px; margin-bottom: 4px;">{{ each.from_member.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ each.from_member.position }}</span></div>
                                        <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #808080;">
                                            {{ each.from_member && each.from_member.place ? each.from_member.place.name : ''}}
                                            <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                                            {{ each.insert_date | agoDateStr }}
                                        </div>
                                    </div>
                                </div>
                                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;">
                                    <CommonPost :preventClick="true" :isChat="true" :isDetail="true" :isFeed="true" :soccerHows="each.soccerhow"></CommonPost>
                                    <div style="display: flex; gap: 8px; justify-content: center;">
                                        <div @click="cofirmRejectOrAccept(false, each.idx, i)" style="width: 107px; height: 40px; line-height: 40px; text-align: center; background: #210F031A; border-radius: 20px; font-size: 14px; font-weight: 700;">거절하기</div>
                                        <div @click="cofirmRejectOrAccept(true, each.idx, i, each)" style="width: 107px; height: 40px; line-height: 40px; text-align: center; background: var(--color-main); border-radius: 20px; font-size: 14px; font-weight: 700;">피드백 수락</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div :key="'feedback_' + i" style="padding:10px;">훈련 피드백
                                <button @click="test" style="padding:10px;">거절</button>
                                <button @click="test" style="padding:10px; margin-left:5px;">수락</button>
                                <span>status : {{each.soccerhow}}, is_accpedted {{each.is_accepted}}, is_skip {{each.is_skip}}</span>
                            </div> -->
                        </template>
                        <!-- 채팅 -->
                        <template v-else>
                            <div :key="'chatting_' + i" style="padding:12px;" class="chatting_wrap" @click="showChat(each, i); $Util.sendEventClick('채팅_메시지_자세히보기');">
                                <div style="display:flex; align-items: center;">
                                    <div v-if="each.type == JOIN_CHAT_TYPE.GROUP" style="width:60px; display:grid; place-items: center;">
                                        <div style="">
                                            <ProfileImage style="width: 60px; height: 60px;" :image-path="each.join_thumbnail_path"></ProfileImage>
                                        </div>
                                    </div>
                                    <div v-if="each.type == JOIN_CHAT_TYPE.MERCENARY_REQUEST || each.type == JOIN_CHAT_TYPE.MERCENARY_PROPOSE" style="width:60px; display:grid; place-items: center;">
                                        <div style="display:grid; place-items: center; font-size:0px;">
                                            <ProfileImage :image-path="each.image_path" style="width:60px; height:60px; border-radius:50%;" :writer-type="each.single_member_type" :is-show-border="false" />
                                        </div>
                                    </div>
                                    <div v-else-if="each.type == JOIN_CHAT_TYPE.SINGLE || each.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH || each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT" style="width:60px; display:grid; place-items: center;">
                                        <div style="display:grid; place-items: center; font-size:0px;">
                                            <ProfileImage :image-path="each.single_image_path" style="width:60px; height:60px; border-radius:50%;" :writer-type="each.single_member_type" :is-show-border="false" />
                                        </div>
                                    </div>

                                    <div style="flex:1;padding-left:8px;overflow:hidden;">
                                        <div v-if="each.type == JOIN_CHAT_TYPE.SINGLE || each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT" style="font-size:10px; color:#808080; font-weight:bold;">{{ each.target_member_idx == $Util.getAdminMemberIdx() ? '사커하우 고객지원' : '1:1 채팅' }}</div>
                                        <div v-else-if="each.type == JOIN_CHAT_TYPE.MERCENARY_PROPOSE || each.type == JOIN_CHAT_TYPE.MERCENARY_REQUEST" style="font-size:10px; color:#808080; font-weight:bold;">용병톡</div>
                                        <div v-else-if="each.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH" style="font-size:10px; color:#808080; font-weight:bold;">전문가 채팅</div>
                                        <div v-else-if="each.type == JOIN_CHAT_TYPE.GROUP" style="font-size:10px; color:#808080; font-weight:bold; display: flex; align-items: center; gap: 4px;">
                                            <div>멤버톡</div>
                                            <span style="display: inline-block; width: 2px; height: 2px; background-color: #808080; border-radius: 50%;"></span>
                                            <div>{{ each.cur_count }}명</div>
                                        </div>
                                        <div style="font-size:14px; color:#210F03; font-weight:700; margin-top:5px;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">
                                            <span>{{ each.type == JOIN_CHAT_TYPE.SINGLE || each.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH || each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT ? each.single_nic_name : each.title }}</span>
                                            <span v-if="each.single_is_coach == '1'" style="padding-left:5px; ">
                                            <img v-if="each.signle_team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px; vertical-align: bottom;" :src="require('@/assets/img/blue_star.png')" alt="">
                                            <img v-else style="width: 13px; vertical-align: bottom;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                        </span>
                                        </div>
                                        <div style="font-size:12px; color:#606060; line-height:16px; margin-top:5px;overflow: hidden; text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical; font-weight:500;">{{ each.contents_type == '4' ? '이미지' : each.chat_contents }}</div>
                                    </div>

                                    <template v-if="each.type == JOIN_CHAT_TYPE.GROUP || each.type == JOIN_CHAT_TYPE.SINGLE || each.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH || each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT">
                                        <div style="width:70px; display: flex; flex-direction: column; justify-content: center; align-items: flex-end; gap: 6px;">
                                            <div style="border-radius:12px; width:33px ;height:20px; text-align: right; color:white; font-size:14px; display:grid; place-items: center;" :style="{ backgroundColor: each.chat_seq_diff > 0 ? '#210f03' : 'white' }">{{ each.chat_seq_diff > 0 ? each.chat_seq_diff : '&nbsp;' }}</div>
                                            <div style="font-size:12px; color:#606060; text-align:right; font-weight: 500; width:100%; display: flex; white-space: nowrap; gap: 4px; justify-content: flex-end; align-items: center;">
                                                <div>{{ each.insert_date | agoDateStr }}</div>
                                                <div v-if="each.type == JOIN_CHAT_TYPE.SINGLE" style="display: flex; gap: 4px; align-items: center;">
                                                    <span v-if="each.read_count == 0" style="display: inline-block; width: 2px; height: 2px; background-color: #808080; border-radius: 50%;"></span>
                                                    <div v-if="each.read_count == 0" style="color: #909090;">읽음</div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </template>
                    </template>
                </template>

            </InfinityScroll>
        </Transition>

        <div style="width: 100%; position: relative;">
            <PageBottom :isShowMakeFeed="false"></PageBottom>
        </div>

        <CommonPopupFrame :changeBottom="0" :changeHeight="modalHeight" :changeHeightUnit="'px'" :isOpen="isShowModal" :closeCompleteAction="closeModal">
            <div v-if="curModalType === MODAL_TYPE.ACCEPT" style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 12px;">
                    <div v-if="!isExpert" style="font-weight: 700; font-size: 20px; line-height: 33px;">다이렉트 메시지를 수락하고<br>감독님과의 채팅을 오픈할까요?</div>
                    <div v-else style="font-weight: 700; font-size: 20px; line-height: 24px;">다이렉트 요청서를 수락하고<br>선수와의 채팅을 오픈할까요?</div>
                    <div v-if="!isExpert" style="display: flex; gap: 10px; font-weight: 500; color: #606060; justify-content: center; margin-top: 20px;">
                        <span style="display: inline-block; margin-top: 10px; width: 5px; height: 5px; border-radius: 50%; background: #808080;"></span>
                        <div style=" line-height: 24px;">원활한 상담 및 소통을 위해 메시지를 보낸 곳<br>이 <span style="font-weight: 700; color: #210F03;">어떤 팀</span>인지 다시 한번 확인해주세요.</div>
                    </div>
                    <div v-else style="display: flex; gap: 10px; font-weight: 500; color: #606060; justify-content: center; margin-top: 20px;">
                        <span style="display: inline-block; margin-top: 10px; width: 5px; height: 5px; border-radius: 50%; background: #808080;"></span>
                        <div style=" line-height: 24px;">원활한 상담 및 소통을 위해 메시지를 보낸 사<br>람이 <span style="font-weight: 700; color: #210F03;">어떤 선수</span>인지 다시 한번 확인해주세요.</div>
                    </div>
                </div>
                <div @click="openChatting" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 237px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">채팅 오픈하기</div>
            </div>
            <div style="padding: 16px 20px;" v-else-if="curModalType === MODAL_TYPE.REJECT">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div v-if="!isExpert" style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">다이렉트 메시지를 거절할까요?</div>
                <div v-else style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">다이렉트 요청서를 거절할까요?</div>
                <div @click="confirmRejectDirectMessage" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">확인</div>
            </div>
            <div v-else-if="curModalType === MODAL_TYPE.JOIN" style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">멤버톡에 참여할까요?</div>
                <div @click="enterJoin" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">참여하기</div>
            </div>
        </CommonPopupFrame>
        <BookmarkPopup :height="473" :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
            <div style="display: flex; flex-direction: column; height: 100%;">
                <div>
                    <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                </div>
                <div style="flex: 1; position: relative;">
                    <div style="display: flex; margin-top: 53px; padding: 0 32px; align-items: center; justify-content: space-between;">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage :image-path="coach_member.image_path" style="width: 100px;"></ProfileImage>
                            <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ coach_member.nic_name }}</div>
                                <div>
                                    <img v-if="coach_member.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage :image-path="user_member.image_path" style="width: 100px;"></ProfileImage>
                            <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ user_member.nic_name }}</div>
                                <div style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ user_member.position }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 40px; text-align: center;">
                        <div style="font-weight: 700; font-size: 20px; line-height: 32px;">채팅을 오픈했습니다👏<br>입단 테스트 일정을 잡으세요!</div>
                    </div>
                    <div @click="showPesonalChat" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 237px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">대화 시작하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions" />
    </div>
</template>

<script>
import InfinityScroll from '@/components/common/InfinityScroll'
import ProfileImage from '@/components/common/ProfileImage'
// import RoundProfileImage from '@/components/common/RoundProfileImage'
import { MEMBER_TYPE, JOIN_CHAT_HISTORY_TYPE, JOIN_CHAT_TYPE, FORM_MODE, JOIN_STATE, MEMBER_TALK_BOX_TYPE, MAIN_TYPE, PAGE_NAME, TEAM_TYPE, DIRECT_MESSAGE_TYPE, POPUP_TYPE } from '@/Constants'
import PageBottom from '@/components/common/PageBottom.vue'
import MemberListNew from '@/components/common/MemberListNew'
// import MemberTalkBox from '@/components/common/MemberTalkBox'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '@/ResponseCode'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import CommonPost from '@/components/soccerhowmain/CommonPost'
import SwipedHomeBannerSmall from "@/components/common/home/SwipedHomeBannerSmall";
import InteractionOfScale from '@/components/common/InteractionOfScale';
import OptionBtn from '@/components/common/OptionBtn'
import {OPEN_CHAT_REGIONS} from "../../Constants";
import CommonApiCall from "../../modules/CommonApiCall";
import BottomPopupMenu from "../common/BottomPopupMenu";
import MemberTalkList from "../common/MemberTalkList";


const MODAL_TYPE = {
    ACCEPT: '메시지수락',
    REJECT: '메시지거절',
    JOIN: '멤버톡참여'
}

const BTN_TYPE = {
    RECRUIT: '멤버모집',
    MESSAGE: '메시지'
}

const MESSAGE_BTN_TYPE = {
    ALL : '전체',
    MESSAGE: '메시지',
    DIRECT_MESSAGE: '다이렉트메시지',
    DIRECT_REQUEST: '다이렉트요청서',
    TRAINING_FEEDBACK: '훈련 피드백'
}

const MEMBERTALK_BTN_TYPE = {
    CLOSE_MERCENARY : '가까운 용병',
    FRIEND : '내 친구',
}

export default {
    name: 'MyChattings',
    components: {
        MemberTalkList,
        BottomPopupMenu, SwipedHomeBannerSmall,
        InfinityScroll, OptionBtn, InteractionOfScale, MemberListNew, ProfileImage, PageBottom, CommonPopupFrame, BookmarkPopup, CommonPost },
    props: {

    },
    data() {
        return {
            DIRECT_MESSAGE_TYPE: DIRECT_MESSAGE_TYPE,
            MEMBERTALK_BTN_TYPE : MEMBERTALK_BTN_TYPE,
            TEAM_TYPE: TEAM_TYPE,
            PAGE_NAME: PAGE_NAME,
            isEnableNextPageHandle: false,
            page: 1,
            pageRecruit: 1,
            JOIN_CHAT_HISTORY_TYPE: JOIN_CHAT_HISTORY_TYPE,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            MEMBER_TALK_BOX_TYPE: MEMBER_TALK_BOX_TYPE,
            MEMBER_TYPE: MEMBER_TYPE,
            memberIdx: '',
            BTN_TYPE: BTN_TYPE,
            curType: BTN_TYPE.MESSAGE,
            curMessageBtnType: MESSAGE_BTN_TYPE.ALL,
            MESSAGE_BTN_TYPE: MESSAGE_BTN_TYPE,
            chatList: [], //멤버톡 리스트가져옴
            isEnableNextPageHandleRecruit: false,
            directRequestList: [],
            modalHeight: 0,
            // directMessageList: [],
            nationwideList: OPEN_CHAT_REGIONS,
            isShowModal: false,
            MODAL_TYPE: MODAL_TYPE,
            curModalType: MODAL_TYPE.ACCEPT,
            curIndex: -1,
            detailInfo: {},
            isShowBookmarkPopup: false,
            chatIdx: -1,
            nearbyMercenaryList: [],
            coach_member: {},
            user_member: {},
            messages : [],
            prev_messages : [],
            tabs : [],
            friends : [],
            cur_membertalk_btn_type : MEMBERTALK_BTN_TYPE.CLOSE_MERCENARY,
            cur_age_sort_key : '모든 나이대',
            cur_tag_sort_key : '멤버톡 태그',
            menuOptions : {},
            isShowPopMenu : false,
            initSetTabIndex: 0,
            isShowSwitchBtn: false,
            direct_messages : [],
            feedbackCnt: 0,
            messageBanners: []
        }
    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
    },
    beforeDestroy() {
        window.my_chatting_refresh_target = null;
    },
    mounted () {
        if (this.$route.query.isFromService) {
            this.initSetTabIndex = 1
            this.setTopBtn(BTN_TYPE.RECRUIT)
        }
        this.isShowSwitchBtn = true
    },
    created() {
        this.openChat = this.$Once(this.openChat)
        this.enterJoin = this.$Once(this.enterJoin)
        this.rejectOrAcceptDierectMessage = this.$Once(this.rejectOrAcceptDierectMessage)

        window.my_chatting_refresh_target = this.refreshTarget;

        const tabs = [];
        tabs.push({
            name : '메시지',
            action : () => {
                this.setTopBtn(BTN_TYPE.MESSAGE);
            }
        });
        if (this.$GlobalStore.isLogin()) {
            if(this.$GlobalStore.loginInfo().is_coach == 1){
                tabs.push({
                    name : '회원 관리',
                    action : () => {
                        this.setTopBtn(BTN_TYPE.RECRUIT);
                    }
                });
            }else {
                tabs.push({
                    name: '멤버',
                    action: () => {
                        this.setTopBtn(BTN_TYPE.RECRUIT);
                    }
                });
            }
        }

        this.tabs = tabs;

        this.refresh();

        if (this.$GlobalStore.isLogin()) {
            this.getFriends();
        }

        this.getMadeByMeChatList()
        this.getNearbyMercenary()

        if (this.$route.query.is_direct_message === 'true') {
            this.setTopBtn(BTN_TYPE.MESSAGE);
            if (this.isExpert) {
                this.setMessageBtnType(MESSAGE_BTN_TYPE.DIRECT_REQUEST)
            } else {
                this.setMessageBtnType(MESSAGE_BTN_TYPE.DIRECT_MESSAGE)
            }
        } else if (this.$route.query.is_message === 'true') {
            this.setTopBtn(BTN_TYPE.MESSAGE);
        }
        this.getMessageBanners()

        // //TODO 테스트용
        // this.curType = BTN_TYPE.RECRUIT;
        // this.cur_membertalk_btn_type = MEMBERTALK_BTN_TYPE.FRIEND

    },
    methods: {
        async getMessageBanners() {
            const res = await this.$Axios.get('/api/chat/banners')
            this.messageBanners = res.data.message_banners
        },
        showMyFriendsPopup(){
            this.$GlobalStore.addModal('MyFriendsPopup', {transitionName: 'bottom', isModalBackTransparent: true})
        },
        showFriendsList() {
            this.$GlobalStore.addModal('FriendsList', { member_idx: this.$GlobalStore.loginInfo().idx})
        },
        showAgeFilters(){
            const labelAndAction = [];
            labelAndAction.push(
                {
                    label: '모든 나이대', action: () => {
                        this.cur_age_sort_key = '모든 나이대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '10대', action: () => {
                        this.cur_age_sort_key = '10대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '20대', action: () => {
                        this.cur_age_sort_key = '20대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '30대', action: () => {
                        this.cur_age_sort_key = '30대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '40대', action: () => {
                        this.cur_age_sort_key = '40대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '50대', action: () => {
                        this.cur_age_sort_key = '50대';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                },
                {
                    label: '60대 이상', action: () => {
                        this.cur_age_sort_key = '60대 이상';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false;
                    },
                }
            );

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            };

            this.isShowPopMenu = true
        },
        showTagFilters(){
            const labelAndAction = [];
            labelAndAction.push(
                {
                    label: '모든 태그', action: () => {
                        this.cur_tag_sort_key = '멤버톡 태그';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '매치 뛰기', action: () => {
                        this.cur_tag_sort_key = '매치 뛰기';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '용병 모집', action: () => {
                        this.cur_tag_sort_key = '용병 모집';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '조기축구', action: () => {
                        this.cur_tag_sort_key = '조기축구';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '친목', action: () => {
                        this.cur_tag_sort_key = '친목';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '국내축구', action: () => {
                        this.cur_tag_sort_key = '국내축구';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '해외축구', action: () => {
                        this.cur_tag_sort_key = '해외축구';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '팬클럽', action: () => {
                        this.cur_tag_sort_key = '팬클럽';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '경기 직관', action: () => {
                        this.cur_tag_sort_key = '경기 직관';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '레슨', action: () => {
                        this.cur_tag_sort_key = '레슨';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '훈련', action: () => {
                        this.cur_tag_sort_key = '훈련';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '유소년', action: () => {
                        this.cur_tag_sort_key = '유소년';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
                {
                    label: '여자축구', action: () => {
                        this.cur_tag_sort_key = '여자축구';
                        this.page = 1;
                        this.chatList = [];
                        this.getMadeByMeChatList();
                        this.isShowPopMenu = false
                    },
                },
            );

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }

            this.isShowPopMenu = true
        },
        setMemberTalkBtnType(membertalk_btn_type){
            this.cur_membertalk_btn_type = membertalk_btn_type;
        },
        toggleMore(index){
            if(this.$hasOwnProperty(this.messages[index], 'is_show_more')){
                this.$delete(this.messages[index], 'is_show_more');
            } else {
                this.$set(this.messages[index], 'is_show_more', true);
            }

        },
        async getFriends(){
            const parameters = {};
            parameters.member_idx = this.$GlobalStore.loginInfo().idx;

            const res = await this.$Axios.get('/api/member/friend/mine', {params : parameters});
            this.friends = res.data.member_friends;
        },
        async refreshTarget(chat_idx) {
            if (this.$route.path !== '/view/mychat') return;
            let chat_index = this.messages.findIndex(each => each.chat_idx == chat_idx);
            if (chat_index > -1) {
                const parameters = {};
                parameters.chat_idx = chat_idx;
                const res = await this.$Axios.get('/api/chat/chats', { params: parameters });
                this.$set(this.messages, chat_index, res.data.joinChats[0]);
            }
        },
        showCoachChat(i) {
            this.$Axios.showPersonalChat(this.direct_messages[i].from_member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_WITH_COACH);
            // if (this.isExpert) {
            //     this.$Axios.showPersonalChat(this.directRequestList[i].from_member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_WITH_COACH);
            // } else {
            //     this.$Axios.showPersonalChat(this.directMessageList[i].from_member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_WITH_COACH);
            // }
        },
        showReqeustDetail(requestDetail) {
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_TEAM_JOINING, isModalBackTransparent: true, isExpert: true, soccerhowIdx: requestDetail.refer_idx, isFromChatRuqest: true })
        },
        async openChat(region_name, regionInfo) {
            if (this.$GlobalStore.isLogin()) {
                const openChatKey = `${region_name} 오픈 멤버톡`
                const parameters = {};
                parameters.open_chat_name = openChatKey;
                const res = await this.$Axios.post('/api/chat/check/joined/openchat', parameters);
                if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                    return;
                }
                await this.$Axios.showChattingBySoccerJoinIdx(res.data.chat_idx, () => { }, false, () => { }, regionInfo);
            }

            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
        },
        async getNearbyMercenary() {
            const res = await this.$Axios.get('/api/member/close/list')

            this.nearbyMercenaryList = res.data.members
        },
        async getMyMessageList() {
            const parameters = {}
            parameters.page = 1
            if (this.curMessageBtnType === MESSAGE_BTN_TYPE.TRAINING_FEEDBACK) {
                parameters.direct_message_types = [DIRECT_MESSAGE_TYPE.FEEDBACK]
            } else if (this.curMessageBtnType === MESSAGE_BTN_TYPE.DIRECT_REQUEST) {
                parameters.direct_message_types = [DIRECT_MESSAGE_TYPE.REQUEST_TO_COACH]
            }
            const res = await this.$Axios.get('/api/direct_message/mine', { params: parameters })

            // if (this.isExpert) {
            //     this.directRequestList = res.data.direct_message
            // } else {
            //     this.directMessageList = res.data.direct_message
            // }

            this.direct_messages = res.data.direct_message
            this.feedbackCnt = res.data.feedback_cnt
        },
        async showPesonalChat() {
            this.isShowBookmarkPopup = false;
            await this.$Axios.showChattingBySoccerJoinIdx(this.chatIdx);
        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
        },
        openChatting() {
            this.isShowModal = false;
            this.rejectOrAcceptDierectMessage(true, this.messages[this.curIndex].idx)
            // if (!this.isExpert) {
            //     this.rejectOrAcceptDierectMessage(true, this.messages[this.curIndex].idx)
            // } else {
            //     this.rejectOrAcceptDierectMessage(true, this.messages[this.curIndex].idx)
            // }
        },
        confirmRejectDirectMessage() {
            this.rejectOrAcceptDierectMessage(false, this.messages[this.curIndex].idx)
            // if (!this.isExpert) {
            //     this.rejectOrAcceptDierectMessage(false, this.messages[this.curIndex].idx)
            // } else {
            //     this.rejectOrAcceptDierectMessage(false, this.messages[this.curIndex].idx)
            // }
        },
        async enterJoin() {
            this.$GlobalStore.showProgress()
            const formData = new FormData
            formData.append('join_idx', this.detailInfo.idx);
            const res = await this.$Axios.post('/api/join/member/apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            this.$GlobalStore.hideProgress()
            if (res.data.code === ResponseCode.SUCCESS) {
                this.detailInfo.is_me_joined = true;
                this.isShowModal = false;
                this.$Util.sendEventClick("멤버톡_참여", true)
                this.showChat({ chat_idx: res.data.chat_idx, idx: this.detailInfo.idx }, this.curIndex, true)
            } else if (res.data.code === ResponseCode.FAIL) {
                alert(res.data.msg)
            }
        },
        showMakeMemberTalk() {
            this.$GlobalStore.addModal('MakeMemberMngChat', { completeAction: this.refresh })
        },
        joinMemberTalkConfirm(detailInfo, i) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.detailInfo = detailInfo
            this.curIndex = i;
            if (this.detailInfo.is_me_joined) {
                this.showChat(this.detailInfo, i, true)
                return
            }
            this.curModalType = MODAL_TYPE.JOIN
            this.modalHeight = 232
            this.isShowModal = true
        },
        async cofirmRejectOrAccept(is_accepted, messageIdx, curIndex, messageInfo){
            this.curIndex = curIndex;
            if (is_accepted) {
                this.$GlobalStore.addModal('SendTrainingFeedback', { messageInfo: messageInfo, completeAction: this.rejectOrAcceptDirectMessageOnFeedback})
            } else {
                if (confirm('피드백 요청을 거절하시겠습니까?')) {
                    this.rejectOrAcceptDirectMessageOnFeedback(is_accepted, messageIdx)
                }
            }
            // await this.rejectOrAcceptDirectMessageOnFeedback(true, 200, '테스트 피드백');
        },
        async rejectOrAcceptDirectMessageOnFeedback(is_accepted, messageIdx, feedback_message){
            const formData = new FormData()
            formData.append('is_accepted', is_accepted)
            formData.append('direct_message_idx', messageIdx)
            formData.append('feedback_message', feedback_message)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData);
            if(res.data.code === ResponseCode.SUCCESS){
                if(is_accepted){
                    this.$set(this.messages[this.curIndex], 'is_accepted', 1);
                    this.chatIdx = res.data.chat_idx;
                    this.$GlobalStore.closeLastModal()
                    this.feedbackCnt--
                    // TODO 팝업 같은게 있을경우 이부분을 팝업에서 확인 누른 후 실행하도록 할것.
                    await this.$Axios.showChattingBySoccerJoinIdx(this.chatIdx);
                }else {
                    this.$set(this.messages[this.curIndex], 'is_skip', 1)
                    this.feedbackCnt--
                }
            } else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async rejectOrAcceptDierectMessage(is_accepted, messageIdx) {
            const formData = new FormData()
            formData.append('is_accepted', is_accepted)
            formData.append('direct_message_idx', messageIdx)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData)

            if (res.data.code === 0) {
                let prev_direct_message;

                // if (!this.isExpert) {
                    prev_direct_message = window.copyObject(this.messages[this.curIndex]);
                    this.$delete(this.messages, this.curIndex)
                // } else {
                //     prev_direct_message = window.copyObject(this.messages[this.curIndex]);
                //     this.$delete(this.messages, this.curIndex)
                // }

                if (!is_accepted) {
                    this.closeModal()
                } else {
                    this.chatIdx = res.data.chat_idx
                    // this.isShowBookmarkPopup = true
                    if (prev_direct_message) {
                        if (prev_direct_message.from_member.is_coach == '1') {
                            this.coach_member = prev_direct_message.from_member;
                            this.user_member = prev_direct_message.to_member;
                            this.$GlobalStore.addModal('DirectMessagePopupModal', {
                                transitionName: '',
                                isModalBackTransparent: true,
                                popupType: POPUP_TYPE.CHAT_OPEN,
                                left_member: this.user_member,
                                right_member: this.coach_member,
                                chat_idx: this.chatIdx
                            })
                        } else if (prev_direct_message.to_member.is_coach == '1') {
                            this.coach_member = prev_direct_message.to_member;
                            this.user_member = prev_direct_message.from_member;
                            this.$GlobalStore.addModal('DirectMessagePopupModal', {
                                transitionName: '',
                                isModalBackTransparent: true,
                                popupType: POPUP_TYPE.CHAT_OPEN,
                                left_member: this.coach_member,
                                right_member: this.user_member,
                                chat_idx: this.chatIdx
                            })
                        }
                    }
                }
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                this.closeModal()
            }
        },
        closeModal() {
            this.isShowModal = false
            this.detailInfo = {}
        },
        setModal(type, i) {
            this.curModalType = type
            if (this.curModalType === MODAL_TYPE.ACCEPT) {
                this.modalHeight = 322
            } else {
                this.modalHeight = 232
            }
            this.curIndex = i
            this.isShowModal = true
        },
        setMessageBtnType(type) {
            this.curMessageBtnType = type;
            this.refresh();
        },
        setTopBtn(type) {
            this.curType = type
        },
        handleNextPageRecruit() {
            this.pageRecruit++
            this.getMadeByMeChatList()
        },
        showPersonalChatFromProfile(member_idx){
            CommonApiCall.showPersonalChat(member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.SINGLE);
        },
        async getMadeByMeChatList() {
            this.isEnableNextPageHandleRecruit = false

            const parameters = {}
            parameters.page = this.pageRecruit;
            parameters.state = JOIN_STATE.OPEN;
            parameters.is_with_members = true;
            parameters.is_with_chat = true;
            if (this.isExpert) {
                parameters.my_type = 'all';
            } else {
                parameters.is_without_coach_made = true;
            }

            if(this.cur_age_sort_key !== '모든 나이대') parameters.age = this.cur_age_sort_key;
            if(this.cur_tag_sort_key !== '멤버톡 태그') parameters.join_tag = this.cur_tag_sort_key;

            const res = await this.$Axios.get('/api/join/list', { params: parameters })
            const joinList = res.data.joins

            if (joinList.length > 0) {
                this.isEnableNextPageHandleRecruit = true
                this.chatList = [...this.chatList, ...joinList]
            }
        },
        refreshRecruit() {
            this.pageRecruit = 1
            this.chatList = []
            this.getMadeByMeChatList()
        },
        makeMemberTalk() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }

            if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;

            this.$GlobalStore.addModal("MakeMemberTalkNew", {completeAction : this.refresh})
        },
        async refresh() {
            this.page = 1;
            // this.directMessageList = [];
            // this.directRequestList = [];
            this.direct_messages = []
            this.messages = [];

            if(this.curMessageBtnType === MESSAGE_BTN_TYPE.ALL || this.curMessageBtnType === MESSAGE_BTN_TYPE.MESSAGE){
                await this.getMyMessageList();
                await this.getMessages()
            } else {
                await this.getMyMessageList();
                // if (this.isExpert) {
                //     this.messages = this.directRequestList;
                // }else {
                //     this.messages = this.directMessageList;
                // }

                this.messages = this.direct_messages;
                console.log(this.messages)

                this.prev_messages = window.copyObject(this.messages);
            }
        },
        handleNextPage() {
            this.page++
            this.getMessages()
        },
        async showChat(each, i, is_join = false) {
            this.$Util.sendEventClick('멤버_멤버톡_채팅보기')
            //고객지원
            if (each.type == JOIN_CHAT_TYPE.SINGLE && each.single_member_type && each.single_member_type == MEMBER_TYPE.USER && each.target_member_idx == this.$Util.getAdminMemberIdx()) {
                this.$Util.showChatWithAdmin();
            //회원이 전문가와 채팅
            } else if (each.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT) {
                await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
            //멤버톡, 개인채팅
            } else {
                this.showJoinChat(each.chat_idx, each.title, each.idx, i, is_join);
            }
        },
        async showJoinChat(chat_idx, title, join_idx, index, is_join) {
            await this.$Axios.showChattingBySoccerJoinIdx(chat_idx, this.getMessages, false, async (mode) => {
                //멤버톡
                if (is_join) {
                    const parameters = {}
                    parameters.state = JOIN_STATE.OPEN;
                    parameters.is_with_members = true;
                    parameters.is_with_chat = true;
                    if (this.isExpert) {
                        parameters.my_type = 'all'
                    }

                    parameters.join_idx = join_idx;
                    const res = await this.$Axios.get('/api/join/list', { params: parameters })
                    if (res.data.joins) {
                        this.$set(this.chatList, index, res.data.joins);
                    } else {
                        this.$delete(this.chatList, index);
                    }

                //멤버톡, 전문가, 개인 채팅 닫을때
                } else {
                    const parameters = {};
                    parameters.chat_idx = chat_idx;
                    const res = await this.$Axios.get('/api/chat/chats', { params: parameters });

                    if (mode === FORM_MODE.DELETE) {
                        this.$set(this.messages, index, res.data.joinChats[0]);
                        this.$delete(this.messages, index)
                    } else {
                        const cur_chat = res.data.joinChats[0];

                        if (cur_chat.contents_idx && cur_chat.contents_idx != this.messages[index].contents_idx) {
                            this.$delete(this.messages, index)
                            this.messages = [cur_chat, ...this.messages];
                        }
                    }
                }
            });
        },
        async getMessages(mode, index){
            if (mode === FORM_MODE.DELETE) {
                this.$delete(this.messages, index)
                return
            }

            this.isEnableNextPageHandle = false;

            const parameters = {};
            parameters.page = this.page;
            const res = await this.$Axios.get('/api/chat/chats', { params: parameters });
            const cur_messages = res.data.joinChats;
            this.memberIdx = res.data.member_idx;

            let direct_message = [];
            // if(this.isExpert){
            //     direct_message = this.directRequestList;
            // }else {
            //     direct_message = this.directMessageList;
            // }
            direct_message = this.direct_messages;

            let merged_messages = [];

            if(this.page === 1){
                this.prev_messages = [];
            }

            /* 채팅과 다이렉트 메시지 시간순 병합 처리*/
            if (cur_messages.length > 0) {
                this.isEnableNextPageHandle = true;

                if(this.curMessageBtnType === MESSAGE_BTN_TYPE.ALL){
                    if(direct_message.length > 0){
                        const prev_messages = this.prev_messages;
                        let i = 0;
                        let j = 0;

                        if(prev_messages.length > 0){
                            const last_prev_message = prev_messages[prev_messages.length - 1];
                            for(let k = 0; k < direct_message.length; k++){
                                if(this.$hasOwnProperty(last_prev_message, 'status')){
                                    // console.log('status', last_prev_message.last_top_update, direct_message[k].last_top_update);
                                    if(last_prev_message.last_top_update < direct_message[k].last_top_update){
                                        j = k + 1;
                                    }
                                }else {
                                    // console.log('not status', last_prev_message.insert_date, direct_message[k].last_top_update);
                                    if(last_prev_message.insert_date < direct_message[k].last_top_update){
                                        j = k + 1;
                                    }
                                }
                            }
                        }

                        /*eslint-disable no-constant-condition */
                        while(1===1){
                            // console.log('j', j);
                            if(direct_message.length - 1 < j || cur_messages[i].insert_date >= direct_message[j].last_top_update){
                                merged_messages.push(cur_messages[i]);
                                i++;
                            } else {
                                merged_messages.push(direct_message[j]);
                                j++;
                            }

                            if(cur_messages.length <= i) break;
                        }
                    }else {
                        merged_messages = cur_messages;
                    }
                } else {
                    merged_messages = cur_messages;
                }

                this.messages = [...this.messages, ...merged_messages];
            } else { //page가 0일때 다이렉트 메시지 나머지 추가.
                if(this.curMessageBtnType === MESSAGE_BTN_TYPE.ALL){
                    const prev_messages = this.prev_messages;
                    if(prev_messages.length > 0){
                        const last_prev_message = prev_messages[prev_messages.length - 1];
                        for(let i = 0; i < direct_message.length; i++){
                            if(this.$hasOwnProperty(last_prev_message, 'status')){
                                if(direct_message[i].last_top_update < last_prev_message.last_top_update){
                                    merged_messages.push(direct_message[i]);
                                }
                            } else {
                                if(direct_message[i].last_top_update < last_prev_message.insert_date){
                                    merged_messages.push(direct_message[i]);
                                }
                            }
                        }

                    }else {
                        merged_messages = direct_message;
                    }
                }

                this.messages = [...this.messages, ...merged_messages];
            }

            this.prev_messages = window.copyObject(this.messages);

        },
    },
}
</script>

<style scoped>
.top_btn {
    width: 98px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}


.message_top_btn {
    border-radius: 24px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ebebeb;
    font-size: 14px;
    font-weight: 700;
}

.make_member_wrapper {
    background-image:
        linear-gradient(180deg, rgba(33, 15, 3, 0.7) 70%, rgba(33, 15, 3, 0) 100%),
        url('~@/assets/img/make_member_expert.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    /* height: 230px; */
    border-radius: 12px;
    overflow: hidden;
    color: #fff;
    padding: 40px 12px;
}

.make_member_wrapper.common_wrapper {
    background-image:
        linear-gradient(180deg, rgba(33, 15, 3, 0.7) 70%, rgba(33, 15, 3, 0) 100%),
        url('~@/assets/img/make_member_common.jpg');
}
</style>